// ============================================================================
// Utility Functions - MyInvoices Helpers
// ============================================================================

/**
 * getInitials - Extracts first letters from name to create initials
 * Example: "THE JUMBLE WORDS" → "TJ"
 * Example: "John" → "J"
 * @param {string} name - Full name to extract initials from
 * @returns {string} Uppercase initials (max 2 characters) or '?' if no name provided
 */
export const getInitials = (name) => {
    if (!name) return '?';
    return name
        .split(' ')
        .slice(0, 2)
        .map(word => word[0])
        .join('')
        .toUpperCase();
};
